import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionHeading } from './ui/SectionHeading';
import { Plus, Minus } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: '¿La primera consulta de valoración tiene costo?',
    answer: 'Sí, la consulta médica de valoración tiene un costo que se descuenta del precio total si decides realizarte el tratamiento. Durante esta sesión, realizamos un diagnóstico exhaustivo y diseñamos un plan personalizado.'
  }, {
    question: '¿Los tratamientos son dolorosos?',
    answer: 'La mayoría de nuestros tratamientos son mínimamente invasivos y prácticamente indoloros. Utilizamos anestesia tópica o local cuando es necesario para garantizar tu máximo confort durante todo el procedimiento.'
  }, {
    question: '¿Cuánto tiempo duran los resultados?',
    answer: 'La duración varía según el tratamiento y el paciente. Por ejemplo, el ácido hialurónico puede durar entre 9 y 18 meses, mientras que la toxina botulínica dura entre 4 y 6 meses. En la consulta te explicaremos detalladamente qué esperar.'
  }, {
    question: '¿Puedo reincorporarme a mi rutina inmediatamente?',
    answer: 'En la gran mayoría de los tratamientos faciales y corporales no invasivos, puedes retomar tus actividades diarias de inmediato. Te indicaremos si se requiere algún cuidado específico post-tratamiento.'
  }, {
    question: '¿Qué productos y tecnología utilizan?',
    answer: 'Trabajamos exclusivamente con marcas premium reconocidas a nivel mundial y aparatología médica certificada por la FDA y CE, garantizando la máxima seguridad y eficacia en cada procedimiento.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 md:py-32 bg-surface" data-id="element-42">
      <div className="container mx-auto px-6 md:px-12 max-w-4xl" data-id="element-43">
        <SectionHeading title="Preguntas Frecuentes" subtitle="Resolvemos tus dudas para que tomes la mejor decisión con total tranquilidad." data-id="element-44" />

        <div className="mt-16 space-y-4" data-id="element-45">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-46">
              <div className={`border border-border rounded-2xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'bg-background shadow-sm' : 'bg-surface hover:bg-background/50'}`} data-id="element-47">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-6 flex items-center justify-between text-left" data-id="element-48">
                  <span className="font-serif text-xl text-foreground pr-8" data-id="element-49">
                    {faq.question}
                  </span>
                  <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${openIndex === index ? 'bg-gold text-gold-foreground' : 'bg-champagne text-gold'}`} data-id="element-50">
                    {openIndex === index ? <Minus className="w-4 h-4" data-id="element-51" /> : <Plus className="w-4 h-4" data-id="element-52" />}
                  </div>
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-500 ease-in-out ${openIndex === index ? 'max-h-48 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-53">
                  <p className="text-muted-foreground font-light leading-relaxed" data-id="element-54">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}